import ModalSelectWithLabel from "@/components/form/hook-form/modal-select-with-label";
import { useViewportHeight } from "@/hooks/utils/use-viewport-height";
import { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { GoalOption, GoalSelectModal } from "./goal-select-modal";

type GoalModalSelectProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  error?: string;
  options?: GoalOption[];
};

const defaultGoalOptions: GoalOption[] = [
  { value: "gain-weight", name: "Gain Weight" },
  { value: "lose-weight", name: "Lose Weight" },
  { value: "maintain-weight", name: "Maintain Weight" },
];

export const GoalModalSelect = <T extends FieldValues>({
  form,
  name,
  error,
  options = defaultGoalOptions,
}: GoalModalSelectProps<T>) => {
  const viewportHeight = useViewportHeight();

  return (
    <ModalSelectWithLabel
      control={form.control}
      name={name}
      label="Goal"
      placeholder="Choose..."
      options={options}
      error={error}
      initialBreakpoint={410 / viewportHeight}
      renderModalContent={({ onSelect }) => (
        <GoalSelectModal
          defaultValue={(form.getValues(name) as string) ?? "lose-weight"}
          options={options}
          onSelect={onSelect}
        />
      )}
    />
  );
};

export default GoalModalSelect;
